<template>
  <div>
    <footer class="lg:px-8 max-w-7xl mt-20 mx-auto px-6 relative">
      <div class="border-border-level-200 border-t dark:border-border-inverse/10 py-12">
        <nav
          class="flex flex-wrap gap-x-6 gap-y-2"
          :aria-label="$t('public.footer.navigationLabel')"
        >
          <NuxtLink
            to="/about-us"
            class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
          >
            {{ $t('public.footer.meetTheTeam') }}
          </NuxtLink>

          <NuxtLink
            to="/partners"
            class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
          >
            {{ $t('public.footer.forRestaurants') }}
          </NuxtLink>
        </nav>

        <div class="md:flex md:items-center md:justify-between md:mt-12 mt-10">
          <div class="flex flex-wrap gap-x-6 gap-y-2 md:order-2">
            <NuxtLink
              to="/privacy-policy"
              class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
            >
              {{ $t('public.footer.privacyPolicy') }}
            </NuxtLink>

            <NuxtLink
              to="/terms-conditions"
              class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
            >
              {{ $t('public.footer.termsConditions') }}
            </NuxtLink>
          </div>

          <div
            class="dark:text-content-level-400 md:mt-0 md:order-1 mt-8 text-content-level-600 text-left text-sm/6"
          >
            <p>
              {{ $t('public.footer.valueMealzIncAllRightsReserved', { value: currentYear }) }}
            </p>

            <p class="dark:text-content-level-500 mt-2 text-content-level-500 text-xs">
              <I18nT
                scope="global"
                keypath="public.footer.thisSiteIsProtectedByRecaptchaAndThe"
                ><template #privacyPolicy
                  ><a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="dark:hover:text-content-level-300 hover:text-content-level-700 underline"
                  >
                    {{ $t('public.footer.privacyPolicy') }}
                  </a></template
                >

                <template #termsOfService
                  ><a
                    href="https://policies.google.com/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="dark:hover:text-content-level-300 hover:text-content-level-700 underline"
                  >
                    {{ $t('public.footer.termsOfService') }}
                  </a></template
                ></I18nT
              >
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'AppFooter' })

const currentYear = new Date().getFullYear()
</script>
